export default __webpack_public_path__ + "static/media/LogoHome.a603cd6e.png";